export default function createToolLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `tool:${input.type}` });
    return {
        registrationStarted(name) {
            return log({
                type: "registration:started",
                details: { name },
            });
        },
        registered(name) {
            return log({
                type: "registration:finished",
                details: { name },
            });
        },
        deregistered(name) {
            return log({
                type: "deregistered",
                details: { name },
            });
        },
    };
}
